import type { MarketplaceListing } from '../types/marketplace';

export const SHOWCASE_LISTINGS: MarketplaceListing[] = [
  {
    id: 'showcase-1',
    slug: 'ios-minimalist-icon-pack',
    title: 'Minimalist iOS & macOS Icon Pack',
    description: 'Transform your home screen and desktop with over 500 hand-crafted vector icons in sleek monochrome, dark mode, and frosted glass variants. Includes custom wallpapers and setup guide.',
    shortDescription: 'Over 500 hand-crafted vector icons with custom wallpapers for iOS & macOS.',
    type: 'digital-product',
    category: 'Design & Graphics',
    price: 19,
    pricePrefix: null,
    currency: 'EUR',
    billingInterval: null,
    pricingType: 'one-time',
    images: [
      'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=1000&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=1000&auto=format&fit=crop&q=80',
    ],
    imageUrl: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=1000&auto=format&fit=crop&q=80',
    metadata: {
      deliverable: 'Instant ZIP download with PNG, SVG and iOS shortcuts',
      filesIncluded: '520 icons + 24 4K wallpapers',
      compatibility: 'iOS 16+, macOS Sonoma, Android',
    },
    ratingAverage: 4.9,
    ratingCount: 142,
    createdAt: '2026-08-15T12:00:00Z',
    publishedAt: '2026-08-15T12:00:00Z',
    seller: {
      id: 'seller-lucas',
      username: 'lucasdesign',
      name: 'Lucas van Dijk',
      avatarUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&auto=format&fit=crop&q=80',
      verification: {
        kind: 'marketplace-compliance',
        label: 'Verified Creator',
      },
    },
    href: '/@lucasdesign/ios-minimalist-icon-pack',
    featured: true,
    facts: [
      { label: 'Format', value: 'SVG & PNG' },
      { label: 'Access', value: 'Instant Download' },
    ],
    raw: {
      id: 'showcase-1',
      title: 'Minimalist iOS & macOS Icon Pack',
      price: 19,
      type: 'digital',
      category: 'Design',
      seller_handle: 'lucasdesign',
      status: 'published',
    },
  },
  {
    id: 'showcase-2',
    slug: 'saas-modern-figma-design-system',
    title: 'Modern SaaS UI Kit & Design System',
    description: 'A comprehensive, production-tested Figma design system with 80+ pre-built application pages, 400+ interactive components, autolayout 5.0, variables, and dark mode tokens ready for development.',
    shortDescription: '80+ responsive pages and 400+ interactive Figma components with dark mode support.',
    type: 'digital-product',
    category: 'Development & UI/UX',
    price: 49,
    pricePrefix: null,
    currency: 'EUR',
    billingInterval: null,
    pricingType: 'one-time',
    images: [
      'https://images.unsplash.com/photo-1581291518655-9523c93269c4?w=1000&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?w=1000&auto=format&fit=crop&q=80',
    ],
    imageUrl: 'https://images.unsplash.com/photo-1581291518655-9523c93269c4?w=1000&auto=format&fit=crop&q=80',
    metadata: {
      deliverable: 'Figma Community file invite & component library link',
      pages: '80+ responsive views',
      variables: 'Color, typography, spacing tokens',
    },
    ratingAverage: 5.0,
    ratingCount: 89,
    createdAt: '2026-08-20T10:00:00Z',
    publishedAt: '2026-08-20T10:00:00Z',
    seller: {
      id: 'seller-sophie',
      username: 'sophieui',
      name: 'Sophie Laurent',
      avatarUrl: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=200&auto=format&fit=crop&q=80',
      verification: {
        kind: 'marketplace-compliance',
        label: 'Verified Creator',
      },
    },
    href: '/@sophieui/saas-modern-figma-design-system',
    featured: true,
    facts: [
      { label: 'Tool', value: 'Figma' },
      { label: 'Components', value: '400+' },
    ],
    raw: {
      id: 'showcase-2',
      title: 'Modern SaaS UI Kit & Design System',
      price: 49,
      type: 'digital',
      category: 'UI/UX',
      seller_handle: 'sophieui',
      status: 'published',
    },
  },
  {
    id: 'showcase-3',
    slug: 'fullstack-architecture-code-audit',
    title: 'Senior Architecture Review & Code Audit',
    description: 'Get an in-depth 1-on-1 code audit and architecture review of your web application or mobile app by a former staff engineer. Includes performance profiling, security checks, and actionable refactoring plan.',
    shortDescription: 'In-depth code review, security audit, and performance profiling for web & mobile apps.',
    type: 'service',
    category: 'Engineering & Code',
    price: 149,
    pricePrefix: 'from',
    currency: 'EUR',
    billingInterval: null,
    pricingType: 'one-time',
    images: [
      'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=1000&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=1000&auto=format&fit=crop&q=80',
    ],
    imageUrl: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=1000&auto=format&fit=crop&q=80',
    metadata: {
      turnaround: '3 business days',
      deliverables: 'Written report, GitHub PR comments & 45-min Zoom debrief',
    },
    ratingAverage: 4.95,
    ratingCount: 38,
    createdAt: '2026-08-25T14:00:00Z',
    publishedAt: '2026-08-25T14:00:00Z',
    seller: {
      id: 'seller-devon',
      username: 'devontech',
      name: 'Devon Bakker',
      avatarUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&auto=format&fit=crop&q=80',
      verification: {
        kind: 'marketplace-compliance',
        label: 'Verified Professional',
      },
    },
    href: '/@devontech/fullstack-architecture-code-audit',
    featured: true,
    facts: [
      { label: 'Turnaround', value: '3 Days' },
      { label: 'Format', value: 'PR & Call' },
    ],
    raw: {
      id: 'showcase-3',
      title: 'Senior Architecture Review & Code Audit',
      price: 149,
      type: 'service',
      category: 'Engineering',
      seller_handle: 'devontech',
      status: 'published',
    },
  },
  {
    id: 'showcase-4',
    slug: 'nextjs-agentic-ai-masterclass',
    title: 'Agentic AI & Next.js 15 Masterclass',
    description: 'Learn to build real-world autonomous AI agents using LangChain, Supabase, Next.js, and streaming tool calls. 14 hours of high-density video tutorials with complete source repositories.',
    shortDescription: 'Master autonomous AI agents with Next.js 15, Supabase, streaming UI, and tool calling.',
    type: 'course',
    category: 'Education & AI',
    price: 79,
    pricePrefix: null,
    currency: 'EUR',
    billingInterval: null,
    pricingType: 'one-time',
    images: [
      'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1000&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=1000&auto=format&fit=crop&q=80',
    ],
    imageUrl: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1000&auto=format&fit=crop&q=80',
    metadata: {
      duration: '14 hours video',
      modules: '8 comprehensive modules + 4 projects',
      certificate: 'Verifiable completion certificate',
    },
    ratingAverage: 4.92,
    ratingCount: 215,
    createdAt: '2026-09-01T09:00:00Z',
    publishedAt: '2026-09-01T09:00:00Z',
    seller: {
      id: 'seller-elena',
      username: 'elenacodes',
      name: 'Elena Rostova',
      avatarUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&auto=format&fit=crop&q=80',
      verification: {
        kind: 'marketplace-compliance',
        label: 'Verified Educator',
      },
    },
    href: '/@elenacodes/nextjs-agentic-ai-masterclass',
    featured: true,
    facts: [
      { label: 'Lessons', value: '48 Videos' },
      { label: 'Level', value: 'Intermediate' },
    ],
    raw: {
      id: 'showcase-4',
      title: 'Agentic AI & Next.js 15 Masterclass',
      price: 79,
      type: 'course',
      category: 'Education',
      seller_handle: 'elenacodes',
      status: 'published',
    },
  },
  {
    id: 'showcase-5',
    slug: 'wersee-founders-club',
    title: 'Indie Founders & Creators Collective',
    description: 'Join a private, high-signal community of builders, designers and solo entrepreneurs shipping profitable software and digital products. Weekly live teardowns, office hours, and co-working sprints.',
    shortDescription: 'Private mastermind community for creators & solo entrepreneurs with weekly live teardowns.',
    type: 'community',
    category: 'Community & Networking',
    price: 29,
    pricePrefix: null,
    currency: 'EUR',
    billingInterval: 'month',
    pricingType: 'recurring',
    images: [
      'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1000&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=1000&auto=format&fit=crop&q=80',
    ],
    imageUrl: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1000&auto=format&fit=crop&q=80',
    metadata: {
      memberCount: '340+ active members',
      access: 'Discord & Wersee Chat VIP channels',
    },
    ratingAverage: 5.0,
    ratingCount: 96,
    createdAt: '2026-09-05T16:00:00Z',
    publishedAt: '2026-09-05T16:00:00Z',
    seller: {
      id: 'seller-wersee',
      username: 'wersee',
      name: 'Wersee Community',
      avatarUrl: '/brand/wersee-icon-192.png',
      verification: {
        kind: 'marketplace-compliance',
        label: 'Official Wersee Club',
      },
    },
    href: '/@wersee/wersee-founders-club',
    featured: true,
    facts: [
      { label: 'Members', value: '340+' },
      { label: 'Access', value: 'Monthly Pass' },
    ],
    raw: {
      id: 'showcase-5',
      title: 'Indie Founders & Creators Collective',
      price: 29,
      type: 'community',
      pricing_type: 'subscription',
      billing_interval: 'month',
      seller_handle: 'wersee',
      status: 'published',
    },
  },
  {
    id: 'showcase-6',
    slug: 'cyberpunk-lowpoly-3d-asset-pack',
    title: 'Cyberpunk City 3D Low-Poly Asset Kit',
    description: 'Over 120 modular low-poly game assets: neon signs, futuristic vehicles, modular buildings, street furniture, and character models. Fully optimized with Blender, FBX, OBJ and glTF formats.',
    shortDescription: '120+ modular low-poly cyberpunk 3D game models ready for Unity & Unreal Engine.',
    type: 'digital-product',
    category: '3D & Game Dev',
    price: 35,
    pricePrefix: null,
    currency: 'EUR',
    billingInterval: null,
    pricingType: 'one-time',
    images: [
      'https://images.unsplash.com/photo-1634017839464-5c339ebe3cb4?w=1000&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1542751371-adc38448a05e?w=1000&auto=format&fit=crop&q=80',
    ],
    imageUrl: 'https://images.unsplash.com/photo-1634017839464-5c339ebe3cb4?w=1000&auto=format&fit=crop&q=80',
    metadata: {
      formats: 'Blender, FBX, OBJ, glTF / GLB',
      polygonCount: '150 - 2,500 per asset',
      textures: 'PBR 2K textures included',
    },
    ratingAverage: 4.85,
    ratingCount: 67,
    createdAt: '2026-09-10T11:00:00Z',
    publishedAt: '2026-09-10T11:00:00Z',
    seller: {
      id: 'seller-kai',
      username: 'kaistudio',
      name: 'Kai Visser',
      avatarUrl: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&auto=format&fit=crop&q=80',
      verification: {
        kind: 'marketplace-compliance',
        label: 'Verified 3D Artist',
      },
    },
    href: '/@kaistudio/cyberpunk-lowpoly-3d-asset-pack',
    featured: false,
    facts: [
      { label: 'Models', value: '120 Assets' },
      { label: 'Engines', value: 'Unity & Unreal' },
    ],
    raw: {
      id: 'showcase-6',
      title: 'Cyberpunk City 3D Low-Poly Asset Kit',
      price: 35,
      type: 'digital',
      category: '3D',
      seller_handle: 'kaistudio',
      status: 'published',
    },
  },
  {
    id: 'showcase-7',
    slug: 'apple-minimalist-brand-identity',
    title: 'Apple-Grade Minimalist Brand Identity & Guidelines',
    description: 'Custom bespoke brand identity package for tech startups: iconic vector logo mark, bespoke typography pairing, color harmony system, business deck template, and comprehensive 30-page brand guidelines PDF.',
    shortDescription: 'Bespoke minimalist logo design, color palette, typography, and complete brand book.',
    type: 'service',
    category: 'Branding & Design',
    price: 199,
    pricePrefix: 'from',
    currency: 'EUR',
    billingInterval: null,
    pricingType: 'one-time',
    images: [
      'https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?w=1000&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1542744094-3a31f272c490?w=1000&auto=format&fit=crop&q=80',
    ],
    imageUrl: 'https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?w=1000&auto=format&fit=crop&q=80',
    metadata: {
      deliveryTime: '5 business days',
      revisions: '3 rounds included',
      files: 'AI, SVG, PDF, PNG with trademark release',
    },
    ratingAverage: 4.98,
    ratingCount: 52,
    createdAt: '2026-09-12T13:00:00Z',
    publishedAt: '2026-09-12T13:00:00Z',
    seller: {
      id: 'seller-lucas',
      username: 'lucasdesign',
      name: 'Lucas van Dijk',
      avatarUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&auto=format&fit=crop&q=80',
      verification: {
        kind: 'marketplace-compliance',
        label: 'Verified Creator',
      },
    },
    href: '/@lucasdesign/apple-minimalist-brand-identity',
    featured: false,
    facts: [
      { label: 'Turnaround', value: '5 Days' },
      { label: 'Files', value: 'Vector & Book' },
    ],
    raw: {
      id: 'showcase-7',
      title: 'Apple-Grade Minimalist Brand Identity & Guidelines',
      price: 199,
      type: 'service',
      category: 'Design',
      seller_handle: 'lucasdesign',
      status: 'published',
    },
  },
  {
    id: 'showcase-8',
    slug: 'advanced-react-performance-guide',
    title: 'Modern React 19 Performance & Architecture',
    description: 'Step-by-step master course on cutting rendering latency, profiling real-world React apps, memory leaks prevention, concurrent rendering, and server components optimization.',
    shortDescription: 'Deep-dive master course on React 19 performance profiling and render optimization.',
    type: 'course',
    category: 'Engineering & Code',
    price: 45,
    pricePrefix: null,
    currency: 'EUR',
    billingInterval: null,
    pricingType: 'one-time',
    images: [
      'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=1000&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=1000&auto=format&fit=crop&q=80',
    ],
    imageUrl: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=1000&auto=format&fit=crop&q=80',
    metadata: {
      duration: '8 hours of video lessons',
      interactiveCodeSandboxes: '32 interactive exercises',
    },
    ratingAverage: 4.88,
    ratingCount: 178,
    createdAt: '2026-09-15T08:00:00Z',
    publishedAt: '2026-09-15T08:00:00Z',
    seller: {
      id: 'seller-devon',
      username: 'devontech',
      name: 'Devon Bakker',
      avatarUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&auto=format&fit=crop&q=80',
      verification: {
        kind: 'marketplace-compliance',
        label: 'Verified Professional',
      },
    },
    href: '/@devontech/advanced-react-performance-guide',
    featured: false,
    facts: [
      { label: 'Duration', value: '8 Hours' },
      { label: 'Level', value: 'Advanced' },
    ],
    raw: {
      id: 'showcase-8',
      title: 'Modern React 19 Performance & Architecture',
      price: 45,
      type: 'course',
      category: 'Education',
      seller_handle: 'devontech',
      status: 'published',
    },
  },
  {
    id: 'showcase-9',
    slug: 'deep-work-creator-planner-system',
    title: 'Deep Work & Productivity Blueprint',
    description: 'A comprehensive multi-page productivity system and action workbook generated with Wersee Studio AI. Contains 12 interactive modules, daily time-blocking templates, habit trackers, and high-performance checklists.',
    shortDescription: 'Full 12-page structured workbook and planner for focused deep work sprints.',
    type: 'digital-product',
    category: 'Productivity & Habits',
    price: 19,
    pricePrefix: null,
    currency: 'EUR',
    billingInterval: null,
    pricingType: 'one-time',
    images: [
      'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=1000&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=1000&auto=format&fit=crop&q=80',
    ],
    imageUrl: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=1000&auto=format&fit=crop&q=80',
    metadata: {
      format: 'PDF',
      pages: '12',
      studioGenerated: true,
      creation_mode: 'wersee_ai',
      ai_generated: true,
      origin: 'wersee_ai',
    },
    ratingAverage: 4.95,
    ratingCount: 88,
    createdAt: '2026-09-20T10:00:00Z',
    publishedAt: '2026-09-20T10:00:00Z',
    seller: {
      id: 'seller-studio',
      username: 'werseestudio',
      name: 'Wersee AI Studio',
      avatarUrl: '/brand/wersee-icon-192.png',
      verification: {
        kind: 'marketplace-compliance',
        label: 'Wersee AI Verified',
      },
    },
    href: '/@werseestudio/deep-work-creator-planner-system',
    featured: true,
    facts: [
      { label: 'Format', value: 'PDF Guide' },
      { label: 'Source', value: 'Wersee AI' },
    ],
    raw: {
      id: 'showcase-9',
      title: 'Deep Work & Productivity Blueprint',
      price: 19,
      type: 'digital',
      category: 'Productivity',
      creation_mode: 'wersee_ai',
      seller_handle: 'werseestudio',
      status: 'published',
      metadata: {
        studioGenerated: true,
        creation_mode: 'wersee_ai',
        ai_generated: true,
      },
    },
  },
];
